import { render, staticRenderFns } from "./MediaUpdate.vue?vue&type=template&id=ab57dc40&"
import script from "./MediaUpdate.vue?vue&type=script&lang=ts&"
export * from "./MediaUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports